module.exports = __webpack_public_path__ + "marriottBubble.-Vkb0OR8.png";